import React from 'react';
import { Card, Row, Col, Button, Image, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export const TarjetaPresupuestos_cliente = (props) => {
	/* Destructuring the props object. */
	const {
		imagenPaciente,
		nombrePaciente,
		telefono,
		direccion,
		localidad,
		precio,
		servicio,
		fecha,
		horasMin,
		activarPresupuestos,
		TipoNotificaciones,
		id,
		cancelarServicio,
		eliminarServicio,
		confirmar,
		rechazarServicio,
		nombrePrestador,
		telefonoPaciente,
		fechaPaciente,
		prestadorServicio,
	} = props;

	const navigate = useNavigate()


	const renderBotones = () => {
		if (TipoNotificaciones[0] === 'buttonNotificacionesActive') {
		return (
			<Button variant="outline-danger" onClick={() => cancelarServicio(id)}>
				Cancelar
			</Button>
		);
		} else if (TipoNotificaciones[1] === 'buttonNotificacionesActive') {
		return (
			<div className="d-flex flex-column gap-2">
			<Badge bg="success" className="">Confirmado</Badge>
			<Button variant="outline-danger" onClick={() => cancelarServicio(id)}>
				Cancelar
			</Button>
			</div>
		);
		} else if (TipoNotificaciones[2] === 'buttonNotificacionesActive') {
		return (
			<div className="d-flex flex-column gap-2">
			<Badge bg="warning" text="dark" className="">Por confirmar</Badge>
			<Button variant="outline-danger" onClick={() => cancelarServicio(id)}>
				Cancelar
			</Button>
			</div>
		);
		} else if (TipoNotificaciones[3] === 'buttonNotificacionesActive') {
		return (
			<div className="d-flex flex-column gap-2">
			<Button variant="outline-danger" onClick={() => eliminarServicio(id)} className="">
				Eliminar
			</Button>
			<Button
				variant="outline-warning"
				onClick={() =>
				navigate('/resenas', {
					state: { empresa_id: prestadorServicio.id },
				})
				}
			>
				Valorar
			</Button>
			</div>
		);
		}
		return null;
	};

	return (
		// <div className='TarjetaSuperiorPresupuestos-clinete'>
		// 	<div className='TarjetaSuperiorDerPresupuestos'>
		// 		<div className='fotoTarjetaPresupuestos centrador'>
		// 			<img src={imagenPaciente} />
		// 		</div>
		// 		<div className='nombreDescripcionTarjetaPresupuestos'>
		// 			<div className='nombreTarjetaPresupuestos'>
		// 				<h4>{nombrePaciente}</h4>
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Fecha de nacimento:</b> {fechaPaciente}
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Teléfono: </b> {telefono}
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Población: </b> {localidad.nombre}
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Dirección:</b> {direccion}
		// 			</div>
		// 		</div>
		// 	</div>
		// 	<div className='TarjetaSuperiorIzqPresupuestos'>
		// 		<div className='precioTarjetaPresupuestos'>
		// 			<h4>{servicio}</h4>
		// 		</div>
		// 		<div className='infoTarjetaPresupuestos'>
		// 			<b>Prsestador de Servicios:</b>
		// 			{nombrePrestador}
		// 		</div>
		// 		<div className='infoTarjetaPresupuestos'>
		// 			<b>Precio:</b>
		// 			{precio} €
		// 		</div>
		// 		<div className='infoTarjetaPresupuestos'>
		// 			<b>Fecha:</b>
		// 			{fecha}
		// 		</div>
		// 		<div className='infoTarjetaPresupuestos'>
		// 			<b>Duración:</b>
		// 			{horasMin} minutos
		// 		</div>
		// 	</div>
		// 	<div className='buttons-presupuesto'>
		// 		{TipoNotificaciones[0] === 'buttonNotificacionesActive' ? (
		// 			<div className='contentBodyCancelarPresupuestos'>
		// 				<div
		// 					className='button borrarCuenta'
		// 					onClick={() => cancelarServicio(id)}
		// 				>
		// 					<div>
		// 						<b>Rechazar</b>
		// 					</div>
		// 				</div>
		// 			</div>
		// 		) : TipoNotificaciones[1] === 'buttonNotificacionesActive' ? (
		// 			<div className='buttons-presupuesto' /*contentBodyCancelarPresupuestos'*/>
		// 				<div className='servicio-aceptado'>
		// 					<div>Activado</div>
		// 				</div>
		// 				<div
		// 					className='button borrarCuenta'
		// 					onClick={() => cancelarServicio(id)}
		// 				>
		// 					<div>
		// 						<b>Cancelar</b>
		// 					</div>
		// 				</div>
		// 			</div>
		// 		) : TipoNotificaciones[2] === 'buttonNotificacionesActive' ? (
		// 			<div className='buttons-presupuesto' /*contentBodyCancelarPresupuestos'*/>
		// 				<div className='servicio-pre-confirma'>
		// 					<div>Por confirmar</div>
		// 				</div>
		// 				<div
		// 					className='button borrarCuenta'
		// 					onClick={() => cancelarServicio(id)}
		// 				>
		// 					<div>
		// 						<b>Cancelar</b>
		// 					</div>
		// 				</div>
		// 			</div>
		// 		) : (
		// 			TipoNotificaciones[3] === 'buttonNotificacionesActive' && (
		// 				<>
		// 				<div className='contentBodyCancelarPresupuestos'>
		// 					<div
		// 						className='button borrarCuenta'
		// 						onClick={() => eliminarServicio(id)}
		// 					>
		// 						<div>
		// 							<b>Eliminar</b>
		// 						</div>
		// 					</div>
		// 				</div>
		// 				<div className='contentBodyCancelarPresupuestos'>
		// 				<div
		// 					className='button button-valorar'
		// 					onClick={()=>{navigate('/resenas',{state:{empresa_id:prestadorServicio.id}})}}
		// 				>
		// 					<div>
		// 						<b>Valorar</b>
		// 					</div>
		// 				</div>
		// 			</div>
		// 			</>
		// 			)
		// 		)}
		// 	</div>
		// </div>

		 <Card className="p-3 shadow-sm border-0 mb-1">
			<Row className="g-3 align-items-center">
				{/* Columna izquierda: info paciente */}
				<Col md={6} className="d-flex align-items-center">
					<Image src={imagenPaciente} roundedCircle width={80} height={80} className="me-3" />
					<div>
						<h5 className="mb-1">{nombrePaciente}</h5>
						<div><small><strong>Fecha de nacimiento:</strong> {fechaPaciente}</small></div>
						<div><small><strong>Teléfono:</strong> {telefono}</small></div>
						<div><small><strong>Población:</strong> {localidad?.nombre}</small></div>
						<div><small><strong>Dirección:</strong> {direccion}</small></div>
					</div>
				</Col>

				{/* Columna derecha: info servicio */}
				<Col md={4}>
					<h6 className="fw-bold">{servicio}</h6>
					<div><small><strong>Prestador:</strong> {nombrePrestador}</small></div>
					<div><small><strong>Precio:</strong> {precio} €</small></div>
					<div><small><strong>Fecha:</strong> {fecha}</small></div>
					<div><small><strong>Duración:</strong> {horasMin} min</small></div>
				</Col>

				{/* Botones de acción */}
				<Col md={2} className="d-flex flex-column justify-content-center align-items-end">
					<div className="d-flex flex-column gap-2 w-full align-items-end">
						{renderBotones()}
					</div>
				</Col>
			</Row>
			</Card>
	);
};
